<h1 cds-text="title">View Operation</h1>
<app-ax-operation-summary *ngIf="!notFound" [operation]="operation"></app-ax-operation-summary>
<clr-alerts *ngIf="notFound">
  <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
    <clr-alert-item>
      <span>Operation not found</span>
    </clr-alert-item>
  </clr-alert>
</clr-alerts>
